import { requests } from '../../../../utils';
import { BASE_URL } from '../../../../utils/endpoints';
import {
    DiscoveryFavoriteResponse,
    DiscoveryResponse,
    IAddFavoriteUserRequest,
    IDiscoveryDetails,
    IDiscoveryFilter,
    IDiscoveryReaction,
    IFavoritesCount,
    IFavoritesFilter,
    SaveCurrentFilter,
} from './dto/IDiscoveryFilter';
import { BaseModel } from '../../../../model/shared/BaseModel';

export const DiscoveryService = {
    getDiscovery: (filters?: IDiscoveryFilter, queryParams: string = ''): Promise<DiscoveryResponse> =>
        requests.post(`${BASE_URL}brand/discovery?${queryParams}`, filters ?? {}),
    getNbFavorites: (campaignId?: number): Promise<IFavoritesCount> =>
        requests.get(`${BASE_URL}brand/discovery/initial/data/${campaignId}`),
    getFavoriteUsers: (
        filterParams: IFavoritesFilter,
        campaignId?: number
    ): Promise<BaseModel<DiscoveryFavoriteResponse[]>> =>
        requests.get(`${BASE_URL}brand/discovery/list/${campaignId}`, filterParams),
    addFavoriteUser: (
        body: IAddFavoriteUserRequest
    ): Promise<{
        discoveryDetails: IDiscoveryDetails;
    }> => requests.post(`${BASE_URL}brand/discovery/list`, body),
    addNote: (id: number, note: string) => requests.put(`${BASE_URL}brand/discovery/list/note/${id}`, { note }),
    addClientNote: (id: number, clientNote: string) =>
        requests.put(`${BASE_URL}brand/discovery/list/client-note/${id}`, { clientNote }),
    addPriority: (id: number, priority: string | null) =>
        requests.put(`${BASE_URL}brand/discovery/list/priority/${id}`, { priority }),
    addEmail: (id?: number, email?: string | null) =>
        requests.put(`${BASE_URL}brand/discovery/list/email/${id}`, { email }),
    addPrice: (id: number, price?: number | null) =>
        requests.put(`${BASE_URL}brand/discovery/list/price/${id}`, {
            price: (price ?? 0) > 0 ? price : null,
        }),
    addPurchaseOrder: (id: number, influencerPurchaseOrder?: string | null) =>
        requests.put(`${BASE_URL}brand/discovery/list/purchase-order/${id}`, { influencerPurchaseOrder }),
    addReactions: (body: IDiscoveryReaction) => requests.put(`${BASE_URL}brand/discovery/client/reaction`, body),
    saveCurrentFilter: (body: SaveCurrentFilter) =>
        requests.post(`${BASE_URL}brand/discovery/save/current/filters`, body),
};
